module.exports = __webpack_public_path__ + "img/logoAiConsumer.67cf5a8c.png";